import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import {
  BLANK_LAYOUT_ROUTES,
  FORM_DETAIL_TABS,
  FORMS
} from '@constants/routes';

const FormsListPage = lazy(
  () => import('@features/forms/pages/forms-list/FormsListPage')
);

const FormWizardPage = lazy(
  () => import('@features/forms/pages/form-wizard/FormWizardPage')
);

const FormSuccessPage = lazy(
  () => import('@features/forms/pages/form-success/FormSuccessPage')
);

const FormDetailPage = lazy(
  () => import('@features/forms/pages/form-detail/FormDetailPage')
);

/** Full-screen wizard (BlankLayout — no sidebar), same pattern as CreateGroup */
export const FormWizardRoutes: RouteObject[] = [
  {
    path: BLANK_LAYOUT_ROUTES.FORM_CREATE,
    element: <FormWizardPage />
  },
  {
    path: BLANK_LAYOUT_ROUTES.FORM_EDIT,
    element: <FormWizardPage />
  }
];

/** Standard app shell (MainLayout with sidebar) */
export const FormRoutes: RouteObject[] = [
  {
    path: FORMS.HOME,
    element: <FormsListPage />
  },
  {
    path: FORMS.SUCCESS,
    element: <FormSuccessPage />
  },
  {
    path: FORM_DETAIL_TABS.REGISTRATIONS,
    element: <FormDetailPage />
  },
  {
    path: FORM_DETAIL_TABS.DROP_OFFS,
    element: <FormDetailPage />
  },
  {
    path: FORM_DETAIL_TABS.ACTIVITY,
    element: <FormDetailPage />
  },
  {
    path: FORMS.DETAIL,
    element: <FormDetailPage />
  }
];

export default FormRoutes;
